/** The 4px dot between two facts on a row's second line. */
export function MetaDot() {
  return <span aria-hidden className="size-1 shrink-0 rounded-full bg-v2-text-secondary/60" />;
}
